<template>
  <div 
    class="notice-card-wrapper"
    @click="$emit('click')"
  >
    <div class="notice-icon-container">
      <img 
        src="@/assets/notice_img.png" 
        alt="公告" 
        class="notice-icon"
      />
    </div>
    <div class="notice-content">
      <h3 class="notice-title">店家公告</h3>
      <p class="notice-preview">{{ noticePreview }}</p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'StoreNoticeCard',
  emits: ['click'],
  
  computed: {
    ...mapGetters('basic', ['noticeContent']),
    
    // 公告預覽文字（移除 HTML 標籤，限制字數）
    noticePreview() {
      if (!this.noticeContent) {
        return '尚無店家公告'
      }
      
      // 移除 HTML 標籤
      const plainText = this.noticeContent.replace(/<[^>]*>/g, '')
      
      // 限制字數（例如：30 個字）
      const maxLength = 30
      if (plainText.length > maxLength) {
        return plainText.substring(0, maxLength) + '...'
      }
      
      return plainText
    }
  }
}
</script>

<style scoped>
.notice-card-wrapper {
  margin: 16px;
  padding: 20px 16px;
  background: #FFFFFF;
  border-radius: 10px;
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  gap: 16px;
  cursor: pointer;
  transition: box-shadow 0.2s ease;
}

.notice-card-wrapper:hover {
  box-shadow: 2px 2px 12px rgba(0, 0, 0, 0.2);
}

.notice-icon-container {
  width: 43px;
  height: 43px;
  border-radius: 21.5px;
  background: #F4F4F4;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.notice-icon {
  width: 24px;
  height: 24px;
}

.notice-content {
  flex: 1;
  min-width: 0;
}

.notice-title {
  font-size: 20px;
  font-weight: 400;
  color: #000000;
  margin: 0 0 4px 0;
}

.notice-preview {
  font-size: 16px;
  line-height: 24px;
  color: #666666;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
